import React, { FC } from "react";
import "./index.scss";
import { default as RcCollapse, Panel } from "rc-collapse";
import { CollapseProps } from "rc-collapse/es/interface";
import { collapseMotion } from "./collapseMotion";

const Collapse: FC<CollapseProps> & { Panel: typeof Panel } = ({
  ...props
}) => {
  return (
    <RcCollapse openMotion={collapseMotion} destroyInactivePanel {...props} />
  );
};

Collapse.Panel = Panel;

export default Collapse;
